// Boot: load data, engine and images; read the URL; restore a saved file; open the debug panel on ?debug=1.
import { loadData } from './ff-data.js?v=59c5357f3a';
import { loadManifest } from './ff-ui-images.js?v=59c5357f3a';
import { loadConfig, loadShare } from './ff-ui-integrations.js?v=59c5357f3a';
import { createApp } from './ff-ui-app.js?v=59c5357f3a';

const root = document.getElementById('ff');
const debug = new URLSearchParams(location.search).get('debug') === '1' && globalThis.EDENBRIDGE_QUIZ?.settings?.debugAllowed === true;

async function boot() {
  root.classList.add('is-booting');
  const [config, share] = await Promise.all([loadConfig(), loadShare()]);
  let data = null, engine = null;
  try {
    // The engine is only needed at the verdict: it loads on the first tap, not at boot.
    const p = new URLSearchParams(location.search);
    const enginePromise = p.has('m') || p.has('v') || p.has('q') ? import('./ff-engine.js?v=59c5357f3a') : null;
    [data] = await Promise.all([loadData(), loadManifest(document.baseURI)]);
    engine = enginePromise || (() => import('./ff-engine.js?v=59c5357f3a'));
  } catch (e) {
    console.error('FF_DATA', e);
  }

  if (!data || !engine) {
    // Intro still renders; Start becomes the sample sets.
    const { renderIntro } = await import('./ff-ui-screens-intro.js?v=59c5357f3a');
    const stub = {
      dataError: true, introPlayed: false, qById: {}, data: { scents: { scents: [] } },
      savedFile: () => null, restart() {}, reopen() {},
    };
    let stage = root.querySelector(':scope > .ff-stage');
    if (!stage) { stage = document.createElement('div'); stage.className = 'ff-stage'; root.append(stage); }
    stage.replaceChildren();
    root.dataset.ground = 'ink';
    const screen = renderIntro(stub);
    stage.append(screen);
    screen.dispatchEvent(new CustomEvent('ff:mounted'));
    root.classList.remove('is-booting');
    return;
  }

  const app = createApp({ root, data, engine, config: { ...config, debug }, share });
  const warm = () => { app.loadEngine(); removeEventListener('pointerdown', warm, true); removeEventListener('keydown', warm, true); };
  addEventListener('pointerdown', warm, true); addEventListener('keydown', warm, true);
  window.__ff = app; // handy in the console and for headless checks
  await app.boot();
  root.classList.remove('is-booting');

  if (debug) {
    const link = document.createElement('link');
    link.rel = 'stylesheet'; link.href = ((globalThis.EDENBRIDGE_QUIZ?.assetBase ?? '') + 'ff-debug.css?v=59c5357f3a');
    document.head.append(link);
    const { mountDebug } = await import('./ff-ui-debug-panel.js?v=59c5357f3a');
    mountDebug(app);
  }
}

boot();
